<template>
  <div class="admin-shell">
    <aside>
      <div class="brand"><span>S</span><strong>SHEWOBILI</strong></div>
      <p class="label">管理中心</p>
      <nav>
        <RouterLink to="/">总览</RouterLink>
        <RouterLink to="/content">内容</RouterLink>
        <RouterLink to="/migration">迁移</RouterLink>
      </nav>
      <p class="security-note">生产环境必须同时通过 Cloudflare Access 和后台账户认证。</p>
    </aside>
    <section class="workspace">
      <header><h1>运营控制台</h1><span class="environment">LOCAL / STAGING</span></header>
      <RouterView />
    </section>
  </div>
</template>

